
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 51 32"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none"}},[_c('rect',{attrs:{"width":"50.756","height":"32","fill":"#0E4595","rx":"2.718"}}),_c('path',{attrs:{"fill":"#FFF","d":"M18.827 22.708l2.258-13.301h3.611l-2.259 13.301zM35.483 9.694c-.716-.27-1.837-.558-3.237-.558-3.568 0-6.081 1.804-6.103 4.389-.02 1.911 1.795 2.977 3.164 3.613 1.406.652 1.878 1.068 1.872 1.65-.01.892-1.123 1.299-2.16 1.299-1.446 0-2.214-.202-3.4-.698l-.465-.212-.507 2.978c.844.371 2.403.693 4.023.71 3.795 0 6.26-1.784 6.288-4.545.013-1.513-.949-2.664-3.032-3.613-1.262-.616-2.035-1.026-2.027-1.65 0-.552.654-1.143 2.068-1.143a6.617 6.617 0 012.702.51l.324.153.49-2.883m9.292-.287h-2.79c-.865 0-1.512.237-1.891 1.103L34.73 22.7h3.792s.62-1.64.76-2l4.625.006c.108.466.439 1.993.439 1.993h3.35l-2.92-13.292zm-4.427 8.589c.298-.767 1.438-3.718 1.438-3.718-.02.035.297-.77.48-1.27l.243 1.147.836 3.84h-2.997zM3.105 9.407l-.046.277c1.427.347 2.702.849 3.818 1.474l3.204 11.528 3.82-.004 5.686-13.275h-3.825l-3.536 9.07-.376-1.843-.056-.17-1.23-5.934c-.218-.842-.852-1.093-1.636-1.123H3.105z"}})])])
          )
        }
      }
    